import React, { Component } from 'react';
import { connect} from "remx";
import moment from 'moment-with-locales-es6';

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";

class ContentHeaderDateAdd extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            prev_next: ''
        }
       
    }

    prevNextDay(count){
        var type_view = this.props.type_view;
        var date = this.props.date_view;
        if (type_view === 'month'){
            date = moment(date).add(count, 'month');
        } else {
            date = moment(date).add(count, 'days');
        }
        dataStore.setters.setDataDateView(moment(date).locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataMonthView(parseInt(moment(date).locale('id').format('MM'))-1);
        this.setState({prev_next : (count === (+1)) ? 'next' : 'prev'});
    }

    setDataType(type) {
        // dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
    
        dataStore.setters.setDataTypeView(type);
    }

    setNow(){
        dataStore.setters.setDataDateView(moment().locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataTypeView('day');
        dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
        this.setState({prev_next : ''});
    }

    openModalTraffic(){
        dataStore.setters.setModalTraffic(true);
    }

    render(){
        // console.log(this.props.month_view)
        return(
            <React.Fragment>
                <div>
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className={"btn btn-sm btn-white"+(this.state.prev_next === 'prev' ? ' active' : '')} onClick={()=> this.prevNextDay(-1)}><i className="fa fa-angle-left"></i></button>
                        <button type="button" className={"btn btn-sm btn-white"+(this.state.prev_next === 'next' ? ' active' : '')} onClick={()=> this.prevNextDay(+1)}><i className="fa fa-angle-right"></i></button>
                    </div>
                    <button onClick={()=> this.setNow()} type="button" className="btn btn-sm btn-white mg-l-10 text-black-50"
                        disabled={moment(this.props.date_view).locale('id').format('DD MMMM YYYY') === 
                                  moment().locale('id').format('DD MMMM YYYY') ?
                        true : false}>Today
                    </button>
                </div>
                <div>
                <h4 className="mg-b-0 tx-spacing-1 mg-r-50">{(this.props.type_view === 'month') ? 
                                                    moment(this.props.date_view).locale('id').format('MMMM YYYY') : 
                                                    moment(this.props.date_view).locale('id').format('DD MMMM YYYY')}
                </h4>
                </div>
                <div className="d-none d-md-block  mg-r-300">
                    {(this.props.type_view === 'day') &&
                        <button type="button" onClick={() => this.openModalTraffic(true)} className="btn btn-sm btn-primary mg-r-10">Add Traffic
                        </button>
                    }
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className={"btn btn-sm btn-white"+(this.props.type_view === 'month' ? ' active' : '')}  onClick={() => this.setDataType('month')}>Monthly</button>
                        {/* <button type="button" className={"btn btn-sm btn-white"}>Week</button> */}
                        <button type="button" className={"btn btn-sm btn-white"+(this.props.type_view === 'day' ? ' active' : '')} onClick={() => this.setDataType('day')}>Daily</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        month_view : dataStore.getters.getDataMonthView(),
        year_view : dataStore.getters.getDataYearView(),
        date_view : dataStore.getters.getDataDateView(),
    }
}

export default connect(mapStateToProps)(ContentHeaderDateAdd);